import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-no-profile-page',
  templateUrl: './no-profile-page.component.html',
  styleUrls: ['./no-profile-page.component.scss']
})
export class NoProfilePageComponent {

  brand:string;
  constructor(
    private router: Router,
    private authService: AuthService
  ) { 
    this.brand = environment.brand;
  }


  goToLoginPage(){
    this.authService.logout();
    this.router.navigate(['./login']);
  }


}
